var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRateUsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rx: 20,
    ry: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 20            L58.2 38.2            L78 40.2            L63 54            L67.2 74            L50 63.5            L32.8 74            L37 54            L22 40.2            L41.8 38.2 Z",
    fill: "#1B4F91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateUsIcon);
export default __webpack_public_path__ + "static/media/rate-us-icon.bcaccea388c3b1490593153382fd0a12.svg";
export { ForwardRef as ReactComponent };